import api from 'api';
import { ResendVerificationMailRequest } from 'models/AuthBody';
import { User } from 'models/User';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function useResendVerificationMail() {
  const [isLoading, setIsLoading] = useState(false);

  const { popSuccess, popServerError } = useContext(PopNotificationsContext);

  const { t } = useTranslation();

  const resendVerificationMail = useCallback(
    async (
      data?: ResendVerificationMailRequest,
      onSuccess?: (user: User) => void,
    ) => {
      try {
        setIsLoading(true);
        const { data: user } = await api.auth.resendVerificationMail(data);
        popSuccess(t('verificationMailSent'));
        onSuccess?.(user);
      } catch (e) {
        popServerError(e);
      } finally {
        setIsLoading(false);
      }
    },
    [popServerError, popSuccess, t],
  );

  return { isLoading, resendVerificationMail };
}
